<template>
    <div>
        <transition name="slide-fade">
 <v-card
    v-if="edicion == false"   
    class="mx-auto mt-5"
    max-width="400"
    
  >
  <div class="d-flex justify-end">
        <v-btn @click.prevent="exitsingle" class="mx-2" fab dark small color="primary">
            <v-icon dark>mdi-close</v-icon>
        </v-btn>
    </div>
    <v-img
      class="white--text align-end"
      height="200px"
      :src="datos.valor.images[0]?datos.valor.images[0].image:require('@/assets/images/noimage.png')"
    >
    </v-img>
     <v-card-text class="text--primary">
      <div> {{datos.valor.name}} </div>
      <div v-if="datos.type == 'vehiculos'"> {{datos.valor.enrollment}} </div>
      <div v-if="datos.type == 'conductores'"> {{datos.valor.dni}} </div>
      <div v-if="datos.type == 'asignacion'"> {{datos.valor.conductor}} - {{datos.valor.asignacion}} </div>
    </v-card-text>

    <v-card-actions>
      

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
       <v-btn @click.prevent="exitsingle" class="mx-2" fab dark small color="seccundary" v-on="on">
        <v-icon dark>mdi-keyboard-backspace</v-icon>
      </v-btn>
      </template>
      <span>Atras</span>
    </v-tooltip>


    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
       <v-btn @click.prevent="edicion = !edicion" class="mx-2" fab dark small color="primary" v-on="on">
        <v-icon dark>mdi-pencil</v-icon>
      </v-btn>
      </template>
      <span>Edición</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
       <v-btn @click="dialog = !dialog" class="mx-2" fab dark small color="danger" v-on="on">
        <v-icon dark>mdi-delete</v-icon>
      </v-btn>
      </template>
      <span>Eliminar</span>
    </v-tooltip>

   </v-card-actions>
  </v-card>
    </transition>

  <transition name="slide-fade">
    <v-card
    v-if="edicion == true"
    class="mx-auto mt-5"
    max-width="344"
    outlined
    >
    <v-list-item three-line>
      <v-list-item-content>
          
          <v-form>
            
          <v-file-input accept="image/png, image/jpeg, image/bmp" v-model="images" label="Agregar imagen"></v-file-input>
         
          <v-text-field
            v-model="datos.valor.name"
            label="Marca y modelo"
            required
            >
            </v-text-field>

            <v-text-field
            v-model="datos.valor.enrollment"
            label="Placa"
            required
            >
            </v-text-field>
            
             <v-select
              v-model="datos.valor.type"
              :items="tipodeitem"
              label="Tipo de equipo"
            ></v-select>

            <v-autocomplete
            v-model="datos.valor.enterprise.Nombre"
            :items="empresas"
            outlined
            dense
            chips
            small-chips
            label="Empresa propietaria del equipo"
          ></v-autocomplete>

          </v-form>

          

            



      </v-list-item-content>

   
    </v-list-item>

    <v-card-actions>
      
      <v-tooltip bottom>
      <template v-slot:activator="{ on }">
       <v-btn @click.prevent="edicion = !edicion" class="mx-2" fab dark small color="seccundary" v-on="on">
        <v-icon dark>mdi-keyboard-backspace</v-icon>
      </v-btn>
      </template>
      <span>Atras</span>
    </v-tooltip>

    
      
      <v-tooltip bottom>
      <template v-slot:activator="{ on }">
       <v-btn @click.prevent="editar()" class="mx-2" fab dark small color="primary" v-on="on">
        <v-icon dark>mdi-content-save</v-icon>
      </v-btn>
      </template>
      <span>Guardar</span>
    </v-tooltip>
    </v-card-actions>
  </v-card>
</transition>
    <v-dialog
      v-model="dialog"
      width="500"
    >
    <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Eliminar ( {{datos.valor.name}} )
        </v-card-title>

        <v-card-text>
          Estas seguro que quieres Eliminar
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          
          
          <v-btn
            color="primary"
            text
            @click="Borrar"
          >
            Si
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
  
            <v-btn
            color="seccundary"
            text
            @click="dialog = !dialog"
          >
            no
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>



    </div>    
</template>
<script>
import {EditarVehicle, DeleteVehicle} from '../../../../../services/team/vehicle'
export default {

    props:{
        datos:''
    },

    mounted() {
      
      this.$store.dispatch('GetEmpresas');
      return this.$store.dispatch('SelectGetGeneraltMutation', {'type':'edit_vehiculo', 'data':this.datos.valor.enterprise.Nombre})

    },

     data(){
       return{
            overlay: false,
            edicion:false,
            images:[],
            dialog: false,
            tipodeitem:['Vehiculo', 'Maquinaria'],  

            
         }
     },

    computed: {
      empresas(){
            
            var array = new Array
            for (let i = 0; i < this.$store.state.Enterprise.length; i++) {
                if (this.$store.state.Enterprise[i].Nombre != 'Sin asignacion') {
                  array.push(this.$store.state.Enterprise[i].Nombre)  
                }
                
            }
            return array;
        },

        selectEmpresasEdit:{
           get(){
             return this.$store.state.select_edit_vehiculo;
           },
           set(newName){
             return this.$store.dispatch('SelectGeneraltMutation', {'type':'edit_vehiculo', 'data':newName})
           }
           
       },
    },

     methods:{

         exitsingle(){
            this.$store.dispatch('MenuEquipo', false);
          },

          selectempresas(){
            //this.$store.dispatch('selectempresaseditAction', datos.valor.);
          },

         editar:function(){
                this.$store.dispatch('LoadingFetchActions', true);
                var data = new FormData;
                data.append('name', this.datos.valor.name);
                data.append('enrollment', this.datos.valor.enrollment);
                data.append('type', this.datos.valor.type);
                data.append('empresa', this.datos.valor.enterprise.Nombre);
                
                if (this.images) {
                    data.append('images', this.images);    
                }
                EditarVehicle(data, this.datos.valor.id).then(response=>{
                    this.$store.dispatch('GetVehicles');
                    this.$store.dispatch('LoadingFetchActions', false);
                    this.$toastr.success('Se ha modificado el vehículo con éxito');
                    this.exitsingle();
                }).catch(errors=>{
                    console.log(errors);
                    this.$toastr.error(errors, 'Error');
                    this.$store.dispatch('LoadingFetchActions', false);
                });

         },

         Borrar:function(){
             this.$store.dispatch('LoadingFetchActions', true);
             DeleteVehicle(this.datos.valor.id).then(response=>{
                    this.$store.dispatch('GetVehicles');
                    this.$store.dispatch('LoadingFetchActions', false);
                    this.$toastr.success('Se ha eliminado el vehículo con éxito');
                    this.exitsingle();
                }).catch(errors=>{
                    this.$store.dispatch('LoadingFetchActions', false);
                    console.log(errors)
                    this.$toastr.error(errors, 'Error');
               })
         }

     }
}
</script>